import { render, staticRenderFns } from "./CopyScene.vue?vue&type=template&id=3195b0e9"
import script from "./CopyScene.vue?vue&type=script&lang=js"
export * from "./CopyScene.vue?vue&type=script&lang=js"
import style0 from "./CopyScene.vue?vue&type=style&index=0&id=3195b0e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports